import React, { useState } from 'react';
import IDWatch from './IDWatch';
// OI watch list, collapsed by default, at the end of the OI tab (30 Oct, Ashish)
export default function WatchPanel() {
  const [open, setOpen] = useState(false);
  return (<div style={{ margin: '14px 0' }}>
    <button onClick={() => setOpen(!open)} style={{ fontSize: 13, padding: '6px 14px', borderRadius: 6, border: '1px solid rgba(127,127,127,0.4)', background: 'transparent', cursor: 'pointer' }}>
      {open ? 'Hide watch list ▴' : 'Show watch list ▾'}</button>
    {open && <div style={{ marginTop: 8 }}><IDWatch /></div>}
  </div>);
}
